import React from "react";
import { Box, Typography } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";

interface StarRatingProps {
  mistakes: string[];
  showText?: boolean;
}

const StarRating: React.FC<StarRatingProps> = ({
  mistakes,
  showText = true,
}) => {
  // Calculate stars based on mistakes:
  // 0 mistakes = 3 stars
  // 1-2 mistakes = 2 stars
  // 3+ mistakes = 1 star
  const getStarCount = (mistakes: string[]): number => {
    const mistakeCount = mistakes.length;
    if (mistakeCount === 0) return 3;
    if (mistakeCount <= 2) return 2;
    return 1;
  };

  const starCount = getStarCount(mistakes);
  const totalStars = 3;

  return (
    <Box sx={{ textAlign: "center", mb: 2 }}>
      {/* Star display */}
      <Box sx={{ display: "flex", justifyContent: "center", gap: 1, mb: 1 }}>
        {Array.from({ length: totalStars }, (_, index) => (
          <Box key={index} sx={{ fontSize: "3.5rem" }}>
            {index < starCount ? (
              <StarIcon sx={{ color: "#FFD700", fontSize: "inherit" }} />
            ) : (
              <StarBorderIcon sx={{ color: "#666", fontSize: "inherit" }} />
            )}
          </Box>
        ))}
      </Box>

      {/* Mistake details */}
      {showText && mistakes.length > 0 && (
        <Box sx={{ mt: 2, p: 2, bgcolor: "#2a2a2a", borderRadius: 2 }}>
          <Typography variant="body2" color="#aaa" sx={{ mb: 1 }}>
            Room for improvement:
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
            {mistakes.map((mistake, index) => (
              <Typography
                key={index}
                variant="body2"
                color="#ff6b6b"
                sx={{ textAlign: "left", pl: 1 }}
              >
                • {mistake}
              </Typography>
            ))}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default StarRating;
